import React from 'react';
import styled from 'styled-components';

const RatingColoredName: React.FC<{
  rating: number;
  name: string;
  getRatingColorStyle: (rating: number) => { color: string };
}> = ({ rating, name, getRatingColorStyle }) => {
  if (rating >= 3000) {
    return (
      <>
        <Black>{name[0]}</Black>
        <Colored style={getRatingColorStyle(rating)}>{name.substr(1)}</Colored>
      </>
    );
  } else {
    return <Colored style={getRatingColorStyle(rating)}>{name}</Colored>;
  }
};

const Black = styled.span`
  color: #000000;
`;

const Colored = styled.span``;

export default RatingColoredName;
